import { render, staticRenderFns } from "./WaiterList.vue?vue&type=template&id=97416abe&scoped=true&lang=pug"
import script from "./WaiterList.vue?vue&type=script&lang=ts"
export * from "./WaiterList.vue?vue&type=script&lang=ts"
import style0 from "./WaiterList.vue?vue&type=style&index=0&id=97416abe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97416abe",
  null
  
)

export default component.exports